export const UPDATE_USER_PROFILE = `
mutation updateUserProfile($user: UpdateUserProfileInput!) {
    updateUserProfile(createOrUpdateUserProfileInput: $user) {
      primeUser
      firstName
      lastName
      middleName
      suffix
      primaryEmail
      secondaryEmail
      idvRestricted
      phoneNumber
      associations {
        entityId
        entityName
        credentialId
        mfaExpirationDate
        restrictNameForIndividual
        firstName
        lastName
        middleName
        suffix
        username
        title
        email
        phoneNumber
        userType
        isActive
      }
    }
  }`;

  export const UPDATE_IDV_USER_PROFILE = `
  mutation updateIdvUserProfile($user: UpdateUserProfileInput!) {
      updateIdvUserProfile(createOrUpdateUserProfileInput: $user) {
        primeUser
        firstName
        lastName
        middleName
        suffix
        primaryEmail
        secondaryEmail
        idvRestricted
        phoneNumber
        associations {
          entityId
          entityName
          credentialId
          mfaExpirationDate
          restrictNameForIndividual
          firstName
          lastName
          middleName
          suffix
          username
          title
          email
          phoneNumber
          userType
          isActive
        }
      }
    }`; 


export const UPDATE_PASSWORD = `
mutation  updateUserPassword($currentPassword: String!, $newPassword: String!) {
  updatePassword(updatePasswordInput: {currentPassword: $currentPassword, newPassword: $newPassword })
}`
